import { z } from 'zod';

export const Base64ToBuffer = z.string().transform((content) => Buffer.from(content, 'base64'));

export type Base64ToBuffer = z.infer<typeof Base64ToBuffer>;
